import React, { useState } from "react";
import { useQueryClient } from "@tanstack/react-query";
import { api, formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { CalendarClock, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { trackMetaEventOnce } from "@/lib/metaPixel";
import { trackOaiqRegistration } from "@/lib/oaiqPixel";

export default function BusinessOnboarding() {
  const qc = useQueryClient();
  const { user } = useAuth();
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (name.trim().length < 2) { toast.error("Lütfen işletme adını girin"); return; }
    setBusy(true);
    try {
      await api.post("/business/onboard", { business_name: name.trim() });
      trackMetaEventOnce("CompleteRegistration", undefined, user?.email);
      trackOaiqRegistration(user?.email);
      await qc.invalidateQueries();
      toast.success("İşletmeniz oluşturuldu, hoş geldiniz!");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[60] bg-background/95 backdrop-blur flex items-center justify-center p-4" data-testid="onboarding-modal">
      <div className="w-full max-w-md rounded-2xl border border-border bg-card p-7 shadow-xl">
        <div className="w-12 h-12 rounded-xl bg-primary flex items-center justify-center mb-4">
          <CalendarClock className="w-6 h-6 text-primary-foreground" />
        </div>
        <h1 className="text-2xl font-bold">365Rez'e hoş geldiniz 👋</h1>
        <p className="text-muted-foreground mt-1.5 text-sm">
          Başlamadan önce işletmenizin adını belirleyin. Bu ad, rezervasyon sayfanızda ve
          müşterilere giden bildirimlerde görünecektir.
        </p>
        <form onSubmit={submit} className="mt-6 space-y-4">
          <div>
            <Label htmlFor="onb-name">İşletme Adı</Label>
            <Input id="onb-name" value={name} onChange={(e) => setName(e.target.value)} autoFocus
              placeholder="Örn: Elite Kuaför" className="h-12 mt-1.5" data-testid="onboarding-name-input" />
          </div>
          <Button type="submit" disabled={busy} className="w-full h-12 rounded-lg" data-testid="onboarding-submit-btn">
            {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : "Devam Et"}
          </Button>
        </form>
      </div>
    </div>
  );
}
